import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';

/**
 * Route guard for the CSM digest-audience admin surface
 * (`/admin/email-subscriptions`), GF-4773.
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `email_subscriptions.manage` is present.
 * Tenant users and super_users without the grant are bounced to `/home`.
 *
 * Mirrors `tenantMembershipsAdminGuard` — same surface, different permission
 * key.
 */
export const emailSubscriptionsAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes('email_subscriptions.manage')) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
